import { render, staticRenderFns } from "./SelectorList.vue?vue&type=template&id=21732994&"
import script from "./SelectorList.vue?vue&type=script&lang=js&"
export * from "./SelectorList.vue?vue&type=script&lang=js&"
import style0 from "./SelectorList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports